/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Home_Faq_5_0Inputs */

const en_settings_home_faq_5_0 = /** @type {(inputs: Settings_Home_Faq_5_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contact our support team at`)
};

/**
* | output |
* | --- |
* | "Contact our support team at" |
*
* @param {Settings_Home_Faq_5_0Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_home_faq_5_0 = /** @type {((inputs?: Settings_Home_Faq_5_0Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Home_Faq_5_0Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_home_faq_5_0(inputs)
});